import type { AssetsResponse, Eod } from '@zenit/contracts';

// The whole catalog in "Añadir activo" (22 Oct 2026): pages accumulate as the list scrolls, prices fill in for rows that
// have none yet, and listings found to have no data drop out. Pure, so the screen logic stays the prototype's.

/** The loaded pages as one list: prices that arrived applied to rows without one, dropped listings left out. */
export function mergePages(pages: AssetsResponse[], prices: Record<string, Eod | null>, gone: ReadonlySet<string>): AssetsResponse | undefined {
  if (!pages.length) return undefined;
  const results = pages.flatMap(p => p.results).filter(r => !gone.has(r.asset.sym)).map(r => (r.eod || !prices[r.asset.sym] ? r : { ...r, eod: prices[r.asset.sym] }));
  return { markets: pages[0].markets, results, next: pages[pages.length - 1].next };
}

/**
 * The rows still without a price, at most 30 (one request), leaving out the ones asked for already: from `from` (the first
 * row on screen) down, then the ones above, so what the participant is looking at is priced first.
 */
export function unpriced(list: AssetsResponse | undefined, asked: ReadonlySet<string>, from = 0): string[] {
  const rs = list?.results ?? [], at = from < rs.length ? from : 0;
  return [...rs.slice(at), ...rs.slice(0, at)].filter(r => !r.eod && !asked.has(r.asset.sym)).slice(0, 30).map(r => r.asset.sym);
}
